import { useQuery } from '@tanstack/react-query';
import api from './authService';

export const clientInvoiceApi = {
  getPendingSummary: async () => {
    const response = await api.get('/client/invoices/pending-summary');
    return response.data;
  },
  getOne: async (id) => {
    const response = await api.get(`/client/invoices/${id}`);
    return response.data;
  },
};

export const useClientPendingInvoices = (options = {}) =>
  useQuery({
    queryKey: ['client-invoices-pending'],
    queryFn: () => clientInvoiceApi.getPendingSummary(),
    staleTime: 60 * 1000,
    ...options,
  });
